import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import SwiperCore, { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import "./LatestInfo.css";

import chevronLeft from "./assets/svg/chevron-left-large.svg";
import chevronRight from "./assets/svg/chevron-right-large.svg";
import arrowIcon from "./assets/svg/arrow.svg";
import defaultImage from "./assets/image.png";

SwiperCore.use([Navigation, Pagination]);

const LatestInfo = () => {
  const [posts, setPosts] = useState([]);
  const location = useLocation();

  // On /stuttering we want "További cikkek a témában", otherwise "Tudástár"
  const headingText =
    location.pathname === "/stuttering"
      ? "További cikkek a témában"
      : "Tudástár";

  useEffect(() => {
    fetch("https://beszeljegyesulet.hu/wp/wp-json/wp/v2/posts?_embed")
      .then((res) => res.json())
      .then((data) => setPosts(data))
      .catch((err) => console.error("API fetch error:", err));
  }, []);

  return (
    <section className="latestinfo">
      <h2 className="heading-sm">{headingText}</h2>

      <div className="latestinfo-carousel">
        <button className="swiper-button-prev custom-nav" aria-label="Előző">
          <img src={chevronLeft} alt="" />
        </button>

        <button className="swiper-button-next custom-nav" aria-label="Következő">
          <img src={chevronRight} alt="" />
        </button>

        <Swiper
          spaceBetween={24}
          slidesPerView={3}
          slidesPerGroup={1}
          loop={true}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          pagination={{
            el: ".swiper-pagination",
            clickable: true,
          }}
        >
          {posts.length === 0 ? (
            <SwiperSlide>
              <div className="info-card loading">Betöltés...</div>
            </SwiperSlide>
          ) : (
            posts.map((post) => {
              const featured =
                post._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
                defaultImage;

              const desc =
                post.excerpt?.rendered
                  ?.replace(/<[^>]+>/g, "")
                  ?.substring(0, 180) + "...";

              return (
                <SwiperSlide key={post.id}>
                  <div className="info-card">
                    <img
                      src={featured}
                      alt={post.title.rendered}
                      className="info-image"
                    />

                    <div className="info-content">
                      <h3
                        className="heading-md"
                        dangerouslySetInnerHTML={{
                          __html: post.title.rendered,
                        }}
                      />
                      <p>{desc}</p>

                      <a href={`/posts/${post.slug}`} className="info-link">
                        Tovább{" "}
                        <img
                          src={arrowIcon}
                          alt="nyíl ikon"
                          className="arrow-icon"
                        />
                      </a>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })
          )}

          <div className="swiper-pagination"></div>
        </Swiper>
      </div>
    </section>
  );
};

export default LatestInfo;
